var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":"https://www.foundersport.com/assets/1/6/close-outline.png","alt":"close button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }